/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = once;
function once(fn, scope) {
  var called;
  var result;
  return function () {
    if (called) {
      return result;
    }
    called = true;
    return result = fn && fn.apply(scope || this, arguments);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/drag-helper/utils/once.js
// module id = 751
// module chunks = 0